import { formatDate } from '@/utils/constants';
import { getDesignFingerprint } from '@/components/Drawers/AddUnlayerEmailDrawer/helpers';
import { normalizeDesignJson } from '@/features/unlayerEmailTemplates/unlayerEmailTemplatesApi';

export const UNLAYER_EDITOR_MIN_HEIGHT = 760;
export const CREATE_NEW_SENTINEL = '__create_new__';

export { getDesignFingerprint };

export const compareStrings = (a, b) =>
	String(a ?? '').localeCompare(String(b ?? ''), undefined, { sensitivity: 'base' });

export const getSortValue = (row, field) => {
	if (field === 'name') return row?.name ?? '';
	if (field === 'subject') return row?.subject ?? '';
	if (field === 'type') return row?.type ?? '';
	if (field === 'active') return row?.active ? 1 : 0;
	if (field === 'createdWhen') return Number(row?.createdWhen ?? 0);
	return Number(row?.lastUpdated ?? 0);
};

export const formatDateTime = (value) => {
	if (!value) return '-';
	try {
		return formatDate(value, true);
	} catch (error) {
		return '-';
	}
};

export const buildUnlayerUserContext = ({ userDetails, fallbackEmail }) => ({
	name: userDetails?.name ?? '[User Name]',
	phoneNumber: userDetails?.phoneNumber ?? '',
	username: userDetails?.displayEmail ?? fallbackEmail,
	aboutUser: userDetails?.about ?? userDetails?.role ?? '',
	imageUrl: userDetails?.imageUrl ?? '',
	disclosureUrl: userDetails?.disclosureUrl ?? '',
	linkedIn: userDetails?.linkedIn ?? '',
	fspNumber: userDetails?.fspNumber ?? '',
	signature: userDetails?.signature ?? '',
	email: userDetails?.displayEmail ?? fallbackEmail,
	about: userDetails?.about ?? userDetails?.role ?? '',
	broker: userDetails?.broker,
});

export const sortTemplates = (templates, sortField, sortDirection) => {
	const rows = [...(templates ?? [])];
	return rows.sort((a, b) => {
		const aSortValue = getSortValue(a, sortField);
		const bSortValue = getSortValue(b, sortField);
		let result = 0;

		if (sortField === 'name' || sortField === 'subject' || sortField === 'type') {
			result = compareStrings(aSortValue, bSortValue);
		} else {
			result = Number(aSortValue) - Number(bSortValue);
		}

		if (result === 0) {
			result = compareStrings(a?.name, b?.name);
		}

		return sortDirection === 'asc' ? result : result * -1;
	});
};

export const parseDesignJsonInput = (value) => {
	const trimmedValue = String(value ?? '').trim();
	if (!trimmedValue) {
		return { error: 'Design JSON is required.' };
	}

	try {
		let parsedDesign = JSON.parse(trimmedValue);
		if (typeof parsedDesign === 'string') {
			parsedDesign = JSON.parse(parsedDesign);
		}
		const design = normalizeDesignJson(parsedDesign);
		return { design };
	} catch (error) {
		return {
			error:
				typeof error?.message === 'string' && error.message.length > 0
					? error.message
					: 'Design JSON must be valid JSON.',
		};
	}
};